"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
exports.default = (function (_a) {
    var className = _a.className, iconColor = _a.iconColor, iconName = _a.iconName, style = _a.style, _b = _a.size, size = _b === void 0 ? 4.8 : _b;
    return (React.createElement("svg", { className: className, style: tslib_1.__assign({ width: size + "rem", height: size + "rem" }, style) },
        React.createElement("use", { xlinkHref: "#" + iconName, style: { fill: iconColor } })));
});
